import { Divider, Stack } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';

import {
  ResourceSelectionDynamicViewer,
  type ResourcesScopeType,
} from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualViewer } from './resourceSelectionManualViewer';

export const ResourcesSelectionViewer = ({
  condition,
  conditionTitle,
  resourcesScopeType,
  include,
  exclude,
  dynamicResourcesHeader,
  allExcludedDescription,
  allIncludedDescription,
}: {
  condition?: Condition;
  conditionTitle: string;
  resourcesScopeType: ResourcesScopeType;
  include: string[];
  exclude: string[];
  dynamicResourcesHeader: React.ReactNode;
  allExcludedDescription: string;
  allIncludedDescription: string;
}) => {
  return (
    <Stack direction='column' gap={'40px'} width='100%'>
      <Stack direction='column' gap={'24px'}>
        {dynamicResourcesHeader}
        <ResourceSelectionDynamicViewer
          condition={condition}
          conditionTitle={conditionTitle}
          resourcesScopeType={resourcesScopeType}
          allExcludedDescription={allExcludedDescription}
          allIncludedDescription={allIncludedDescription}
        />
      </Stack>
      <Divider sx={{ borderStyle: 'dashed' }} />
      <ResourceSelectionManualViewer include={include} exclude={exclude} />
    </Stack>
  );
};
